const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || '';
const FDLOG_DOMAIN = process.env.REACT_APP_FDLOG || '';
const EVENT_API = process.env.REACT_APP_EVENT_API || '';

export default {
  REACT_APP_SERVER_DOMAIN: SERVER_DOMAIN,
  REACT_APP_FDLOG: FDLOG_DOMAIN,
  REACT_APP_EVENT_API: EVENT_API,
  REACT_APP_API_HASH: process.env.REACT_APP_API_HASH || '',
  REACT_APP_OPENCAGE_KEY: process.env.REACT_APP_OPENCAGE_KEY || '',
};
